import React from "react";
import HighchartsReact from "highcharts-react-official";
import Highcharts from "highcharts";
import { firstDecimalPlace } from "../../../util/util";
import { DATE_FORMAT } from "../../../constants/CommonConstants";
import moment from 'moment';
import './AvailabilityResultsGraph.css'

export const AvailabilityResultsGraph = (props) => {

    let xAxisCategories = [];
    let printingTimeList = [];
    let preparingPrintingTimeList = [];
    let idleTimeList = [];
    let interruptingPrintingTimeList = [];
    props.analysisDataList.forEach(data => {
        xAxisCategories.push(moment(data.date, DATE_FORMAT).format(props.intl.formatMessage({ id: "date_format2"})) + '(' + props.intl.formatMessage({ id: moment(data.date, DATE_FORMAT).format('ddd') }) + ')');
        printingTimeList.push(firstDecimalPlace(data.printingTime / 3600));
        preparingPrintingTimeList.push(firstDecimalPlace(data.preparingPrintingTime / 3600));
        idleTimeList.push(firstDecimalPlace(data.idleTime / 3600));
        interruptingPrintingTimeList.push(firstDecimalPlace(data.interruptingPrintingTime / 3600));
    });

    return (
        <div className="availability-results-graph">
            <div className="availability-results-graph-title" >{props.intl.formatMessage({ id: "top_operator_subtitle_output_availability_result" })}</div>            
            <div className="zoom-button" style={{backgroundImage: `url(${props.zoomButtonIcon})`}} onClick={props.onFullScreenButtonClick} ></div>
            <HighchartsReact
                highcharts={Highcharts}
                constructorType={"chart"}
                containerProps={{ style: { height: "100%"} }}
                scrollbar={{enabled: true}}
                options={{
                    title: false,
                    chart: {
                        type: 'column'
                    },
                    credits: false,
                    time:{useUTC: false},
                    xAxis: {
                        categories: xAxisCategories,
                        labels: {
                            style: {
                                "fontSize": '14px',
                                "color": '#77777B'
                            }
                        },
                    },
                    yAxis: [{
                        title: false,
                        min: 0,
                        labels: {
                            style: {
                                "fontSize": '14px',
                                "color": '#77777B'
                            }
                        },
                    }],
                    caption: {
                        text: props.intl.formatMessage({ id: "screen3_print_hours" }),
                        verticalAlign: 'top',
                        y: 5,
                        style: {
                            "color": '#77777B',
                            "fontSize": '14px'
                        }
                    },
                    legend: {
                        align: 'center',
                        verticalAlign: 'top',
                        y: -15,
                        backgroundColor: Highcharts.defaultOptions.legend.backgroundColor || 'white',
                        borderWidth: 0,
                        itemStyle: {
                            "color": '#77777B',
                            "fontWeight": 'normal',
                            "fontSize": '14px'
                        },
                        symbolHeight: 10,
                        symbolWidth: 20,
                        squareSymbol: false,
                        symbolRadius: 0
                    },
                    tooltip: {
                        headerFormat: '<b>{point.x}</b><br/>',
                        pointFormat: '{series.name}: {point.y}h'
                    },
                    plotOptions: {
                        column: {
                            stacking: 'normal',
                            dataLabels: {
                                formatter: function() {
                                    return Highcharts.numberFormat(this.x, 0, '', ',');
                                }
                            }
                        },
                        series: {
                            pointWidth: 25,
                            animation: {
                                duration: 1500,
                                easing: 'swing'
                            }
                        },
                    },
                    series: [{
                        name: props.intl.formatMessage({ id: "availabilibydetail_unit_idle" }),
                        data: idleTimeList,
                        color: '#C6C6C6',
                    }, {
                        name: props.intl.formatMessage({ id: "availabilibydetail_unit_interruption" }),
                        data: interruptingPrintingTimeList,
                        color: '#D8D44C',
                    }, {
                        name: props.intl.formatMessage({ id: "availabilibydetail_unit_preparation" }),
                        data: preparingPrintingTimeList,
                        color: '#9B89F4',
                    }, {
                        name: props.intl.formatMessage({ id: "availabilibydetail_unit_printing" }),
                        data: printingTimeList,
                        color: '#2BBCEC',
                    }],
                    exporting: {
                        buttons: {
                            contextButton: {
                                enabled: false
                            },
                        }
                    },
                }}
            />
        </div>
    );
};
